function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.4,
  width: 162.463,
  height: 162.463,
  rx: 40,
  transform: "matrix(-4.37114e-08 1 -0.865988 -0.500065 156.988 81.5091)",
  fill: "#F2F2F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.9,
  width: 162.463,
  height: 162.463,
  rx: 40,
  transform: "matrix(-4.37114e-08 1 -0.865988 -0.500065 140.741 89.6323)",
  fill: "#F2F2F2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "#000"
}, React.createElement("path", {
  d: "M39.2306 101.105C38.3426 100.593 37.6551 100.582 37.168 101.074C36.6809 101.561 36.4374 102.492 36.4375 103.869C36.4377 106.735 37.369 108.705 39.2313 109.78C40.0127 110.231 40.9591 110.552 42.0704 110.742L42.0705 113.028C41.1572 112.94 40.1372 112.571 39.0107 111.92C37.392 110.986 36.1538 109.705 35.2962 108.079C34.4385 106.448 34.0096 104.571 34.0094 102.45C34.0093 101.114 34.2198 100.067 34.6409 99.3079C35.062 98.5432 35.6658 98.1213 36.4523 98.0422C37.2439 97.9602 38.1699 98.2253 39.2305 98.8376C40.3113 99.4617 41.3972 100.39 42.4883 101.624L41.7273 103.399C41.3112 102.93 40.8925 102.49 40.4713 102.076C40.0502 101.663 39.6366 101.34 39.2306 101.105ZM54.5454 114.271C54.5456 116.398 54.089 117.769 53.1757 118.385C52.2624 119 50.9533 118.815 49.2483 117.831C47.5433 116.846 46.2341 115.519 45.3206 113.849C44.4071 112.179 43.9503 110.275 43.9501 108.136C43.95 105.998 44.4065 104.63 45.3198 104.032C46.2382 103.431 47.5524 103.625 49.2625 104.612C50.9726 105.599 52.2792 106.922 53.1826 108.58C54.091 110.241 54.5452 112.138 54.5454 114.271ZM46.4239 109.582C46.424 111.018 46.66 112.235 47.132 113.234C47.604 114.233 48.3093 115.004 49.2481 115.546C51.1307 116.633 52.0719 115.732 52.0717 112.843C52.0714 109.948 51.1351 107.961 49.2627 106.88C48.3239 106.338 47.6161 106.295 47.1391 106.752C46.6622 107.203 46.4238 108.147 46.4239 109.582ZM66.7244 127.745L63.7254 126.013L58.8837 113.498L58.8152 113.458C58.9118 115.231 58.9601 116.483 58.9601 117.216L58.9606 123.262L56.8522 122.045L56.8512 109.196L59.8273 110.914L64.6614 123.328L64.7147 123.359C64.6384 121.645 64.6003 120.443 64.6002 119.751L64.5998 113.669L66.7234 114.895L66.7244 127.745ZM73.826 131.845L71.4664 130.483L71.4656 119.901L68.4438 118.156L68.4436 115.888L76.8468 120.74L76.8469 123.008L73.8252 121.263L73.826 131.845ZM84.9693 138.279L78.5603 134.578L78.5594 121.729L84.9683 125.429L84.9685 127.661L80.9191 125.323L80.9193 128.145L84.6871 130.32L84.6872 132.552L80.9195 130.377L80.9198 133.691L84.9691 136.029L84.9693 138.279ZM97.1706 145.323L94.1716 143.592L89.33 131.076L89.2615 131.036C89.358 132.809 89.4063 134.061 89.4063 134.794L89.4068 140.841L87.2984 139.623L87.2974 126.774L90.2736 128.492L95.1076 140.907L95.1609 140.937C95.0847 139.223 95.0465 138.021 95.0465 137.329L95.046 131.247L97.1696 132.473L97.1706 145.323ZM104.272 149.423L101.913 148.061L101.912 137.479L98.89 135.734L98.8898 133.467L107.293 138.318L107.293 140.586L104.271 138.841L104.272 149.423Z",
  fill: "#333333"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 138.094,
  height: 28.4311,
  fill: "white",
  transform: "matrix(0.866025 0.5 7.54471e-05 1 10.5979 76.3411)"
})));

var SvgContent = function SvgContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 157,
    height: 253,
    viewBox: "0 0 157 253",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Content.4b849b22.svg";
export { ForwardRef as ReactComponent };